var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-layout',{staticStyle:{"background-color":"white"},attrs:{"fill-height":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-dialog',{attrs:{"persistent":"","width":_vm.$vuetify.breakpoint.name == 'xs'
          ? '100vw'
          : _vm.$vuetify.breakpoint.name == 'sm'
          ? '60vw'
          : _vm.$vuetify.breakpoint.name == 'md'
          ? '50vw'
          : _vm.$vuetify.breakpoint.name == 'lg'
          ? '40vw'
          : '30vw'},model:{value:(_vm.queryPopUpDialog),callback:function ($$v) {_vm.queryPopUpDialog=$$v},expression:"queryPopUpDialog"}},[_c('v-card',{attrs:{"tile":"","color":"#FFFFFF"}},[_c('v-layout',{attrs:{"wrap":"","justify-center":"","pa-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('QueryPopUp',{on:{"stepper":_vm.winStepper2}})],1)],1)],1)],1),_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }